import React, { useRef, useState } from 'react';

// React Bits "Spotlight Card" (https://reactbits.dev/components/spotlight-card) —
// a card with a radial spotlight that follows the cursor on hover. Ported to plain
// React + inline styles so it drops into any card shell via `className`.
const SpotlightCard = ({
  children,
  className = '',
  spotlightColor = 'rgba(255, 255, 255, 0.35)',
  ...rest
}) => {
  const divRef = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [opacity, setOpacity] = useState(0);

  const handleMouseMove = (e) => {
    if (!divRef.current) return;
    const rect = divRef.current.getBoundingClientRect();
    setPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  return (
    <div
      ref={divRef}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setOpacity(1)}
      onMouseLeave={() => setOpacity(0)}
      className={className}
      style={{ position: 'relative' }}
      {...rest}
    >
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          opacity,
          pointerEvents: 'none',
          transition: 'opacity 0.4s ease',
          zIndex: 3,
          background: `radial-gradient(circle 180px at ${position.x}px ${position.y}px, ${spotlightColor}, transparent 80%)`,
        }}
      />
      {children}
    </div>
  );
};

export default SpotlightCard;
